<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="create">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        :width="isMB?'60':'90'"
      >
        <template slot-scope="{row}">
          <el-button type="text" :disabled="row.Status=='已扣费'" @click="editById(row.RentMonSetId)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
        </template>
      </el-table-column>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/consume/rentmon/list";
import editDialog from "@/components/consume/rentmon/editDialog";

export default {
  name: "rentmon",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      selectedRows: [],
    }
  },
  methods: {
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.RentMonSetId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>